<footer class="footer">
    <div class="footer-content justify-content-between">
        <p class="m-b-0">Copyright © {{copyrightYear}}.</p>
        <span>
            <a href="javascript:" class="text-gray m-r-15">Term &amp; Conditions</a>
            <a href="javascript:" class="text-gray">Privacy &amp; Policy</a>
        </span>
    </div>
</footer>